import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Gross salary filter: dual range slider and min/max inputs (compact toolbar row).
 */
const GrossSalaryRangeFilter = ({ bounds, value, onChange, idPrefix = "payroll-gross" }) => {
  const { t } = useTranslation();

  const span = Math.max(1, bounds.max - bounds.min);
  const sliderMin = Number.isFinite(Number(value?.min)) ? Number(value.min) : bounds.min;
  const sliderMax = Number.isFinite(Number(value?.max)) ? Number(value.max) : bounds.max;

  const setRange = (min, max) => {
    const lo = Math.max(bounds.min, Math.min(min, max, bounds.max));
    const hi = Math.min(bounds.max, Math.max(min, max, bounds.min));
    onChange({ min: lo, max: hi });
  };

  return (
    <div
      className="payroll-gross-filter payroll-gross-filter--inline"
      role="group"
      aria-labelledby={`${idPrefix}-label`}
    >
      <span className="payroll-gross-filter__toolbar-label" id={`${idPrefix}-label`}>
        {t("app.payroll.assignments.filterGrossSalary")}
      </span>

      <div className="payroll-gross-filter__field">
        <label className="payroll-gross-filter__input-label" htmlFor={`${idPrefix}-min`}>
          {t("app.payroll.assignments.grossMin")}
        </label>
        <input
          id={`${idPrefix}-min`}
          type="number"
          min={bounds.min}
          max={bounds.max}
          className="payroll-gross-filter__number"
          value={value?.min ?? bounds.min}
          onChange={(e) => {
            const v = e.target.value === "" ? bounds.min : Number(e.target.value);
            setRange(v, sliderMax);
          }}
          aria-label={t("app.payroll.assignments.grossMinAria")}
        />
      </div>

      <div className="payroll-gross-filter__slider-row">
        <input
          type="range"
          className="payroll-gross-filter__range payroll-gross-filter__range--min"
          min={bounds.min}
          max={bounds.max}
          step={Math.max(1, Math.round(span / 200))}
          value={Math.min(sliderMin, sliderMax)}
          onChange={(e) => setRange(Number(e.target.value), sliderMax)}
          aria-label={t("app.payroll.assignments.grossMinAria")}
        />
        <input
          type="range"
          className="payroll-gross-filter__range payroll-gross-filter__range--max"
          min={bounds.min}
          max={bounds.max}
          step={Math.max(1, Math.round(span / 200))}
          value={Math.max(sliderMax, sliderMin)}
          onChange={(e) => setRange(sliderMin, Number(e.target.value))}
          aria-label={t("app.payroll.assignments.grossMaxAria")}
        />
      </div>

      <div className="payroll-gross-filter__field">
        <label className="payroll-gross-filter__input-label" htmlFor={`${idPrefix}-max`}>
          {t("app.payroll.assignments.grossMax")}
        </label>
        <input
          id={`${idPrefix}-max`}
          type="number"
          min={bounds.min}
          max={bounds.max}
          className="payroll-gross-filter__number"
          value={value?.max ?? bounds.max}
          onChange={(e) => {
            const v = e.target.value === "" ? bounds.max : Number(e.target.value);
            setRange(sliderMin, v);
          }}
          aria-label={t("app.payroll.assignments.grossMaxAria")}
        />
      </div>
    </div>
  );
};

export default GrossSalaryRangeFilter;
